/** Item State For item */
export enum ItemState {
  Draft = 0,
  Active = 1,
  SellPending = 2,
  Sold = 3,
  Unlisted = 4,
}

/** Item Condition */
export enum ItemCondition {
  New = 0,
  Used = 1,
}

/** NonprofitCategory Type**/
export type NonprofitCategory = Readonly<{
  nonprofitCategoryId?: number
  name?: string
  selected?: boolean
}>

/** Nonprofit */
export type Nonprofit = Readonly<{
  nonprofitId: number
  name?: string
  description?: string
  nonprofitCategoryId?: NonprofitCategory['nonprofitCategoryId']
  nonprofitCategoryName?: NonprofitCategory['name']
  nonprofitUrl?: string
  nonprofitCardUrl?: string
  defaultImageId?: number
  selected?: boolean
  website?: string
  externalId: string
}>

export type ItemDetails = {
  listedItemId: number
  isCurrentUserOwner: boolean
  name: string
  description?: string
  itemCondition: ItemCondition
  currentPrice: number
  state: ItemState
  listedUtc?: Date
  soldUtc?: Date
  createdUtc?: Date
  defaultImageId?: number
  donorName: string
  nonprofit: Nonprofit
  nonprofitName: string
  images: number[]
  version: string
  city: string
  region: string
  isLocalPickupAvailable: boolean
  isShippingAvailable: boolean
  width: number
  height: number
  length: number
  weight: number
}

export type NonprofitDetails = {
  nonProfitId: string,
  externalId: string,
  name: string,
  categoryId: number
  webSite: string
}
